import { render, staticRenderFns } from "./PncpBiddingList.vue?vue&type=template&id=5e061d24&"
import script from "./PncpBiddingList.vue?vue&type=script&lang=js&"
export * from "./PncpBiddingList.vue?vue&type=script&lang=js&"
import style0 from "./PncpBiddingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports